
<val-boite-dialogue-generique #boiteDialogue
                              class="val-boite-dialogue-rg-simple"
                              [titre]="titre"
                              [validerVisible]="false"
                              [annulerVisible]="false">
  <div bandeau
       class="val-boite-dialogue-rg-simple-bandeau">
  </div>
  <div contenu
       class="val-boite-dialogue-rg-simple-contenu val-flex-conteneur">
     <val-simple-image [src]="icone"
                       [ngClass]="{'val-invisible': !iconeVisible}">
     </val-simple-image>
     <val-simple-libelle [libelle]="message"></val-simple-libelle>
  </div>
  <div commandes
       class="val-boite-dialogue-rg-simple-commandes val-flex-conteneur">
    <div class="val-flex-1"></div>
    <val-simple-bouton class="val-boite-dialogue-rg-simple-commande"
                       [ngClass]="{'val-invisible': !boutonOkVisible}"
                       libelle="Ok"
                       (boutonClick)="BoutonClick(1)">
    </val-simple-bouton>
    <val-simple-bouton class="val-boite-dialogue-rg-simple-commande"
                       [ngClass]="{'val-invisible': !boutonOuiVisible}"
                       libelle="Oui"
                       (boutonClick)="BoutonClick(6)">
    </val-simple-bouton>
    <val-simple-bouton class="val-boite-dialogue-rg-simple-commande"
                       [ngClass]="{'val-invisible': !boutonNonVisible}"
                       libelle="Non"
                       (boutonClick)="BoutonClick(7)">
    </val-simple-bouton>
    <val-simple-bouton class="val-boite-dialogue-rg-simple-commande"
                       [ngClass]="{'val-invisible': !boutonAbandonnerVisible}"
                       libelle="Abandonner"
                       (boutonClick)="BoutonClick(3)">
    </val-simple-bouton>
    <val-simple-bouton class="val-boite-dialogue-rg-simple-commande"
                       [ngClass]="{'val-invisible': !boutonRecommencerVisible}"
                       libelle="Recommencer"
                       (boutonClick)="BoutonClick(4)">
    </val-simple-bouton>
    <val-simple-bouton class="val-boite-dialogue-rg-simple-commande"
                       [ngClass]="{'val-invisible': !boutonAnnulerVisible}"
                       libelle="Annuler"
                       (boutonClick)="BoutonClick(2)">
    </val-simple-bouton>
    <val-simple-bouton class="val-boite-dialogue-rg-simple-commande"
                       [ngClass]="{'val-invisible': !boutonIgnorerVisible}"
                       libelle="Ignorer"
                       (boutonClick)="BoutonClick(5)">
    </val-simple-bouton>
  </div>
</val-boite-dialogue-generique>
